import 'fetch-polyfill';

var img = "data:image/png;base64,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";

var icons8MicrosoftPowerpoint201996 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img
});

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAFZUlEQVR4nO3df0yUdRwH8Pf3OEA5kYAJOoJZiSn5i1lZmjZWIXOFG87GamZNaiXLDJP8lb9IWC3MRWVhtDRr1PxRmQqmW84JtgLFyU5b4FQSMj0Ew+AOnm9/tJ7zBvk8wfN9vl/i89rY7vu9z/H93L25557nnmMHEEIIIYQQQgghhJCBgslYNHbT3HSAv8YZJgIItmPN6OS77FgGALwcrAZMyzs9ff0eo2LbA4h9Z85jnLNv7F7XxgD8GM9wT1+/+2YlDrt60XG2xvY1ZdHYCqMS2wPgwHi715SGYYJRif3PACBEwpqyGN5XGQGQG1AAklEAklEAklEAklEAklEAklEAklEAklEAklEAkjnNFLmWTJnHOMsFMBZAUF8WvH6uoS83BxjgcDrhjBgKpyusb79LAYYBuHLuf4pxvtWOZkzhgObrhPeyBwD6fQiGATDwpXY00htez1V4vT5upjbo0kXR7fSKmU3QWOFd9BbXAEmnVa1i5kW4T9t8oUz97auN9oIkowAkowAkowAkowAkM3UkbFZ8ZCx+yi1FWMggfe6L6nJkfba2x/pBzhBUL/sS8ZGx+lzBgRLkl39kZVtKs/QZcKH5NxQd/jxgbm7yIxg3YlSP9QtnZAY8+PWXG7Dx0DYrW1Ke5ZugwkPbcL65yb8Ac+DV1Ge61d0yOByLU54MmMv96m20d3qtbklplgfwp68Dq799L2Bu9vgUTI4PPKBelroAkWFD9fGO49+h3F1hdTvKE/IivPPEQRypq9bHjDEsS12gjxOiRiBraoY+vtbehpV7ikS0ojxhe0FLdhWiU+vSx2lJ03DvyHEAgLWzXkCo0/+p9PX7P8TFlt9FtaI0YQG4m+rxybGvA+ZWzXwOE+ISMWfSQ/rc8YbT2FKxU1QbyhN6HJBXVozm6636OGX0Pdg+vwAO9veyGtfw8o430aVpIttQmtAAPG0teL2sOGDutug4/XJJxW5UXXCLbEF5wo+ESyp341TjL93mL13zYN3+D0QvrzxLj4R7EhIUDFfI4B6vYxacS3FV/mpq+9URE97ntUQQ/gxYOfPZgM3OP2LCo5D3aLYVSzgU/zFsXpiJcaOR/WCmPq5trMOP507p4/lT0jH19kkiW1CesACCHA4UPb4cTof/jOaavZux6oajZMYY3p27POCYYKARFkD2jEwk3zpGH1eerUG5+ygq6k+g3H1Un0+MScDilHmi2lCekAASIodjRWpWwNzqve/rl9fs3QyN+187lz78NO6MHSmiFeUJCaAw4xW4Qv17Pvtqj+DY2ZP6uLaxDqVV5fo41BmMTXNywVi//oRJr1geQObkNKQlTdPHXZqGtfu67+9vKCtGR6dPHz9wRzKeuHuW1e0oz9IAolwRyE9fFDBXWrUf7qb6brXnm5u6vQdUkL4Iw4ZEWtmS8iwNoCD9pYAH0NvlQ8GBj/+1/q2DW9Ha/oc+jgwbig3pL1rZkvIMN7pDcu5T+vNnrtpW4yIAvtljjIsE8CzcddPHmD4VIRkFIBkFIBkFIBkFIJmZALqMS2RRegfNFDMBKHvO0NHe/wMwPCPGwd9gYJ/a0cx/FezxXnEAbWZqo2qvim6nRx6D6w0DaNv4w3ZXzhQwsFwASZD+L0scjnaO4CsdCG7xRXOGaDO3CvKpuSW1/e3H4WlJUrYbEQnDZCyLM8WH6UhYZRSAZBSAZBSAZBSAZBSAZBSAZBSAZBSAZBSAZBSAZDICGEj/CGx4XyUEwE8a1/xv1BgV2P8VJlrQOrvXlIWD5RvV2P7eflvdpZ9diTHVDBgFIMauHgZFuOxYBgB8AKoZZ8+f2fK97d8WRQghhBBCCCGEEELU9RctYEHONU7NKAAAAABJRU5ErkJggg==";

var icons8MicrosoftExcel201996 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$1
});

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAFV0lEQVR4nO2cT0wjVRzHv49Sigus1CxQQONCBVb+ySYIROFm4nKA3XhZE//c1HjZPbkHE7MaExMTSQx6UG/Gk6dF1z8x4bhYkWQJLGwXWeq6ZFu2iECggG3p81CYmU4LUzvTecPw+yQk815/fe/X953f7703fwAIgiAIgiAIgiAIgiCI4wIT0Wn7Z7ODnPP3ADwDwCnChzwSBTDFgA+nL7Ve1zI2XYD24ZkBDnxvdr8i4Jy/NHO57dphNgVmObMPB7tqdp+iYIy9q2VjugAAbzO/T2G0axkIEABFAvoUheZvFSEAoYAEEAwJIBgSQDAkgGBIAMGQAIIhAQRDAgiGBBAMCSCYwqysXvzkNRSwK+B4GoBDT4e3fvpFz9fBGOAqLUNFfR3Ka6t1tWUFtAXoH3odHF+Dm+BNFnAO7GxsYHFqGgCOvAjZRMA7efciR5bnAygvrbbIqZEb2gIk044l+Xd7ExB0W9UospmEdeX8fMKP9LmfhFZBgiEBBEMCCIYEEAwJIJjsdsIH8OWlF/Bmv/zkxeD7I7g+Hkiz62yowsTwKyl1b38+ii9+nE6zHezx4rur56XyVz9P463hUT1uWhpdETA2G0wpdzVl3pX2tT6eVvd8c21G264mz6F92A1dAtyYfZBSVg/ePr0tNWl1fa0HCNCY2oa6D7uhS4DA0jqCK5tSuavJgwKWvjF9rjldgCcrT+KJirKUOsaAzsYqqRxc2URgaV2Pi5ZH9yR8Q5EiyktcaKgtT/m8sdYNj7tEKu9E49KxOgoaa91wlxZnbNuu6BZg7LY6DaXOA8pBfri6hdHJ+1JZPQ90q76rbtuOGBABKgFUOVw5yGO3H8B3JySV1XODeg6xe/4HDBBgKrCMje2oVFYPojICfP4QfH45rbSePoXHyuSU031GjoCN7SimAst63bM8ugXYTXD4/PJZ3eGtgMuZvIBa5T6Bp2rkOcHnD+L3uSXEdxPJzhlDz96gu5wOtJ0+pbANYTdhg8udGhiyEx5TpIqiQgc66isBAH0t8vo/Fk/g5t0wIjsxzPy1ItX3tiQj5Ky3UhJO3aad0bUT3ke9Wulq8mB8LpSS4ycXwtjeWwH5/EF01FcAkFNUev7PbgXEViKJnB23AIZEwPhcCLG4PA77g6ncAStzvzJlPdvoQXFRYYoAsXgC43OyjQYFFv/TdF43kZ0YJhfCUrmryYPSR5xor0vN6fKxLIbL6UBnQ1XKEnRyIZmqjgOGXQ1VLhkbatwY6Pai0CE377sjD/pCaA3L69tSebDHC2+1PFkfh+XnPoYJMHZbHmDGgMsXzkrl0D8R3A9vSGXOgd8U+4E3+tugvIKhbMvuGBoBypvkypTya4YBVaah8hKXdMw5RUBOhNe2MB9czfiZMv1Idf7Mk+x8cBXhtS2j3LI8ht4RO+jMzTTYE3/IG7Js2rArhgqQ6eZJLJ7A5N1wWn1kJ4Zb9/7Oqg07k/cIuLnwUNqAqckUGcctArQf6zs3ZOkLMu1nekW7cCjTn3YfOsb0VIRgSADBkACCIQEEQwIIJhsBdvPuRY4c6Tcz9tAWgMFvgh854XKVaBtZnGxeUfoYwDf5d+X/c5IXr0QWFyOi/dBDdlF8buhVAFcANMMCrywVMSceLSxDqeOEaFc0+XPk4qFjbHoarbvwraV31kajJQCtggRDAgiGBBAMCSAYEkAwJIBgSADBkACCIQEEQwIIhgQQjAgBotomtkHztwoQgKX/fwL7MqVlYLoAjCU+MLtPUXDgIy0b0wUIXHv5B3AMApgAYMe3MKIAJhjjA/dGLo6IdoYgCIIgCIIgCIIgCIKwDv8BtEiDpqoRtAAAAAAASUVORK5CYII=";

var icons8MicrosoftWord201996 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$2
});

var img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAABjElEQVR4nO3dsU7DQBAG4R8UnhNBlfdvIUDvUNln3+zejHRFCluX/XydlSRmZmbX91t0fSV5P2Ee05s92CPrJ8l9/EjmNnuoomyaPVBRNm2/HL32KF1A2qBUB3n88/lz2u4GVB3kI88opU9KdZCkGUoHkKQRSheQpAlKJ5CkAUo3kKQ4SkeQpDBKV5CkKEpnkKQgSneQpBjKCiBJIZRVQJIiKCuBJAVQVgNJ4CgrgiRglFVBEijKyiAJEKU6yFnrkQPvfb3svTDPCEfudUVXPjTfSd72XCjIee2ax+voXdixbrM3cGFnn+AhJ9ATAksQWILAEgSWILAEgSUILEFgCQJLEFiCwBIEliCwBIElCCxBYAkCSxBYgsASBJYgsASBJQgsQWAJAksQWILAEgSWILAEgSUILEFgCQJLEFiCwBIEliCwBIElCCxBYAkCSxBYgsASBJYgsASBJQgsQWAJAksQWILAEgSWILAEgSUILEFgCQJLEFiCwBr52+8V/kMEnycEliCwBDEzM2vSH3E69/RDBrYkAAAAAElFTkSuQmCC";

var icons8File100 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$3
});

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var require$$0 = getCjsExportFromNamespace(icons8MicrosoftPowerpoint201996);

var require$$1 = getCjsExportFromNamespace(icons8MicrosoftExcel201996);

var require$$2 = getCjsExportFromNamespace(icons8MicrosoftWord201996);

var require$$3 = getCjsExportFromNamespace(icons8File100);

// ie10+
var ie10plus = window.navigator.msPointerEnabled;
/**
 * Flow.js is a library providing multiple simultaneous, stable and
 * resumable uploads via the HTML5 File API.
 * @param [opts]
 * @param {number|Function} [opts.chunkSize]
 * @param {bool} [opts.forceChunkSize]
 * @param {number} [opts.simultaneousUploads]
 * @param {bool} [opts.singleFile]
 * @param {string} [opts.fileParameterName]
 * @param {number} [opts.progressCallbacksInterval]
 * @param {number} [opts.speedSmoothingFactor]
 * @param {Object|Function} [opts.query]
 * @param {Object|Function} [opts.headers]
 * @param {bool} [opts.withCredentials]
 * @param {Function} [opts.preprocess]
 * @param {string} [opts.method]
 * @param {string|Function} [opts.testMethod]
 * @param {string|Function} [opts.uploadMethod]
 * @param {bool} [opts.prioritizeFirstAndLastChunk]
 * @param {bool} [opts.allowDuplicateUploads]
 * @param {string|Function} [opts.target]
 * @param {number} [opts.maxChunkRetries]
 * @param {number} [opts.chunkRetryInterval]
 * @param {Array.<number>} [opts.permanentErrors]
 * @param {Array.<number>} [opts.successStatuses]
 * @param {Function} [opts.initFileFn]
 * @param {Function} [opts.readFileFn]
 * @param {Function} [opts.generateUniqueIdentifier]
 * @constructor
 */

function Flow(opts) {
  /**
   * Supported by browser?
   * @type {boolean}
   */
  this.support = typeof File !== 'undefined' && typeof Blob !== 'undefined' && typeof FileList !== 'undefined' && (!!Blob.prototype.slice || !!Blob.prototype.webkitSlice || !!Blob.prototype.mozSlice || false); // slicing files support

  if (!this.support) {
    return;
  }
  /**
   * Check if directory upload is supported
   * @type {boolean}
   */


  this.supportDirectory = /Chrome/.test(window.navigator.userAgent) || /Firefox/.test(window.navigator.userAgent) || /Edge/.test(window.navigator.userAgent);
  /**
   * List of FlowFile objects
   * @type {Array.<FlowFile>}
   */

  this.files = [];
  /**
   * Default options for flow.js
   * @type {Object}
   */

  this.defaults = {
    chunkSize: 1024 * 1024,
    forceChunkSize: false,
    simultaneousUploads: 3,
    singleFile: false,
    fileParameterName: 'file',
    progressCallbacksInterval: 500,
    speedSmoothingFactor: 0.1,
    query: {},
    headers: {},
    withCredentials: false,
    preprocess: null,
    changeRawDataBeforeSend: null,
    method: 'multipart',
    testMethod: 'GET',
    uploadMethod: 'POST',
    prioritizeFirstAndLastChunk: false,
    allowDuplicateUploads: false,
    target: '/',
    testChunks: true,
    generateUniqueIdentifier: null,
    maxChunkRetries: 0,
    chunkRetryInterval: null,
    permanentErrors: [404, 413, 415, 500, 501],
    successStatuses: [200, 201, 202],
    onDropStopPropagation: false,
    initFileFn: null,
    readFileFn: webAPIFileRead
  };
  /**
   * Current options
   * @type {Object}
   */

  this.opts = {};
  /**
   * List of events:
   *  key stands for event name
   *  value array list of callbacks
   * @type {}
   */

  this.events = {};
  var $ = this;
  /**
   * On drop event
   * @function
   * @param {MouseEvent} event
   */

  this.onDrop = function (event) {
    if ($.opts.onDropStopPropagation) {
      event.stopPropagation();
    }

    event.preventDefault();
    var dataTransfer = event.dataTransfer;

    if (dataTransfer.items && dataTransfer.items[0] && dataTransfer.items[0].webkitGetAsEntry) {
      $.webkitReadDataTransfer(event);
    } else {
      $.addFiles(dataTransfer.files, event);
    }
  };
  /**
   * Prevent default
   * @function
   * @param {MouseEvent} event
   */


  this.preventEvent = function (event) {
    event.preventDefault();
  };
  /**
   * Current options
   * @type {Object}
   */


  this.opts = Flow.extend({}, this.defaults, opts || {});
}

Flow.prototype = {
  /**
   * Set a callback for an event, possible events:
   * fileSuccess(file), fileProgress(file), filesAdding(files, event), fileAdded(file, event),
   * fileRemoved(file), fileRetry(file), fileError(file, message),
   * complete(), progress(), error(message, file), pause()
   * @function
   * @param {string} event
   * @param {Function} callback
   */
  on: function (event, callback) {
    event = event.toLowerCase();

    if (!this.events.hasOwnProperty(event)) {
      this.events[event] = [];
    }

    this.events[event].push(callback);
  },

  /**
   * Remove event callback
   * @function
   * @param {string} [event] removes all events if not specified
   * @param {Function} [fn] removes all callbacks of event if not specified
   */
  off: function (event, fn) {
    if (event !== undefined) {
      event = event.toLowerCase();

      if (fn !== undefined) {
        if (this.events.hasOwnProperty(event)) {
          arrayRemove(this.events[event], fn);
        }
      } else {
        delete this.events[event];
      }
    } else {
      this.events = {};
    }
  },

  /**
   * Fire an event
   * @function
   * @param {string} event event name
   * @param {...} args arguments of a callback
   * @return {bool} value is false if at least one of the event handlers which handled this event
   * returned false. Otherwise it returns true.
   */
  fire: function (event, args) {
    // `arguments` is an object, not array, in FF, so:
    args = Array.prototype.slice.call(arguments);
    event = event.toLowerCase();
    var preventDefault = false;

    if (this.events.hasOwnProperty(event)) {
      each(this.events[event], function (callback) {
        preventDefault = callback.apply(this, args.slice(1)) === false || preventDefault;
      }, this);
    }

    if (event != 'catchall') {
      args.unshift('catchAll');
      preventDefault = this.fire.apply(this, args) === false || preventDefault;
    }

    return !preventDefault;
  },

  /**
   * Read webkit dataTransfer object
   * @param event
   */
  webkitReadDataTransfer: function (event) {
    var $ = this;
    var queue = event.dataTransfer.items.length;
    var files = [];
    each(event.dataTransfer.items, function (item) {
      var entry = item.webkitGetAsEntry();

      if (!entry) {
        decrement();
        return;
      }

      if (entry.isFile) {
        // due to a bug in Chrome's File System API impl - #149735
        fileReadSuccess(item.getAsFile(), entry.fullPath);
      } else {
        readDirectory(entry.createReader());
      }
    });

    function readDirectory(reader) {
      reader.readEntries(function (entries) {
        if (entries.length) {
          queue += entries.length;
          each(entries, function (entry) {
            if (entry.isFile) {
              var fullPath = entry.fullPath;
              entry.file(function (file) {
                fileReadSuccess(file, fullPath);
              }, readError);
            } else if (entry.isDirectory) {
              readDirectory(entry.createReader());
            }
          });
          readDirectory(reader);
        } else {
          decrement();
        }
      }, readError);
    }

    function fileReadSuccess(file, fullPath) {
      // relative path should not start with "/"
      file.relativePath = fullPath.substring(1);
      files.push(file);
      decrement();
    }

    function readError(fileError) {
      decrement();
      throw fileError;
    }

    function decrement() {
      if (--queue == 0) {
        $.addFiles(files, event);
      }
    }
  },

  /**
   * Generate unique identifier for a file
   * @function
   * @param {FlowFile} file
   * @returns {string}
   */
  generateUniqueIdentifier: function (file) {
    var custom = this.opts.generateUniqueIdentifier;

    if (typeof custom === 'function') {
      return custom(file);
    } // Some confusion in different versions of Firefox


    var relativePath = file.relativePath || file.webkitRelativePath || file.fileName || file.name;
    return file.size + '-' + relativePath.replace(/[^0-9a-zA-Z_-]/gim, '');
  },

  /**
   * Upload next chunk from the queue
   * @function
   * @returns {boolean}
   * @private
   */
  uploadNextChunk: function (preventEvents) {
    // In some cases (such as videos) it's really handy to upload the first
    // and last chunk of a file quickly; this let's the server check the file's
    // metadata and determine if there's even a point in continuing.
    var found = false;

    if (this.opts.prioritizeFirstAndLastChunk) {
      each(this.files, function (file) {
        if (!file.paused && file.chunks.length && file.chunks[0].status() === 'pending') {
          file.chunks[0].send();
          found = true;
          return false;
        }

        if (!file.paused && file.chunks.length > 1 && file.chunks[file.chunks.length - 1].status() === 'pending') {
          file.chunks[file.chunks.length - 1].send();
          found = true;
          return false;
        }
      });

      if (found) {
        return found;
      }
    } // Now, simply look for the next, best thing to upload


    each(this.files, function (file) {
      if (!file.paused) {
        each(file.chunks, function (chunk) {
          if (chunk.status() === 'pending') {
            chunk.send();
            found = true;
            return false;
          }
        });
      }

      if (found) {
        return false;
      }
    });

    if (found) {
      return true;
    } // The are no more outstanding chunks to upload, check is everything is done


    var outstanding = false;
    each(this.files, function (file) {
      if (!file.isComplete()) {
        outstanding = true;
        return false;
      }
    });

    if (!outstanding && !preventEvents) {
      // All chunks have been uploaded, complete
      async(function () {
        this.fire('complete');
      }, this);
    }

    return false;
  },
  getQuery: function () {
    return this.opts.query;
  },
  setQuery: function (query) {
    this.opts.query = query;
  },

  /**
   * Assign a browse action to one or more DOM nodes.
   * @function
   * @param {Element|Array.<Element>} domNodes
   * @param {boolean} isDirectory Pass in true to allow directories to
   * @param {boolean} singleFile prevent multi file upload
   * @param {Object} attributes set custom attributes:
   *  http://www.w3.org/TR/html-markup/input.file.html#input.file-attributes
   *  eg: accept: 'image/*'
   * be selected (Chrome only).
   */
  assignBrowse: function (domNodes, isDirectory, singleFile, attributes) {
    if (domNodes instanceof Element) {
      domNodes = [domNodes];
    }

    each(domNodes, function (domNode) {
      var input;

      if (domNode.tagName === 'INPUT' && domNode.type === 'file') {
        input = domNode;
      } else {
        input = document.createElement('input');
        input.setAttribute('type', 'file'); // display:none - not working in opera 12

        extend(input.style, {
          visibility: 'hidden',
          position: 'absolute',
          width: '1px',
          height: '1px'
        }); // for opera 12 browser, input must be assigned to a document

        domNode.appendChild(input); // https://developer.mozilla.org/en/using_files_from_web_applications)
        // event listener is executed two times
        // first one - original mouse click event
        // second - input.click(), input is inside domNode

        domNode.addEventListener('click', function () {
          input.click();
        }, false);
      }

      if (!this.opts.singleFile && !singleFile) {
        input.setAttribute('multiple', 'multiple');
      }

      if (isDirectory) {
        input.setAttribute('webkitdirectory', 'webkitdirectory');
      }

      each(attributes, function (value, key) {
        input.setAttribute(key, value);
      }); // When new files are added, simply append them to the overall list

      var $ = this;
      input.addEventListener('change', function (e) {
        if (e.target.value) {
          $.addFiles(e.target.files, e);
          e.target.value = '';
        }
      }, false);
    }, this);
  },

  /**
   * Assign one or more DOM nodes as a drop target.
   * @function
   * @param {Element|Array.<Element>} domNodes
   */
  assignDrop: function (domNodes) {
    if (typeof domNodes.length === 'undefined') {
      domNodes = [domNodes];
    }

    each(domNodes, function (domNode) {
      domNode.addEventListener('dragover', this.preventEvent, false);
      domNode.addEventListener('dragenter', this.preventEvent, false);
      domNode.addEventListener('drop', this.onDrop, false);
    }, this);
  },

  /**
   * Un-assign drop event from DOM nodes
   * @function
   * @param domNodes
   */
  unAssignDrop: function (domNodes) {
    if (typeof domNodes.length === 'undefined') {
      domNodes = [domNodes];
    }

    each(domNodes, function (domNode) {
      domNode.removeEventListener('dragover', this.preventEvent);
      domNode.removeEventListener('dragenter', this.preventEvent);
      domNode.removeEventListener('drop', this.onDrop);
    }, this);
  },

  /**
   * Returns a boolean indicating whether or not the instance is currently
   * uploading anything.
   * @function
   * @returns {boolean}
   */
  isUploading: function () {
    var uploading = false;
    each(this.files, function (file) {
      if (file.isUploading()) {
        uploading = true;
        return false;
      }
    });
    return uploading;
  },

  /**
   * should upload next chunk
   * @function
   * @returns {boolean|number}
   */
  _shouldUploadNext: function () {
    var num = 0;
    var should = true;
    var simultaneousUploads = this.opts.simultaneousUploads;
    each(this.files, function (file) {
      each(file.chunks, function (chunk) {
        if (chunk.status() === 'uploading') {
          num++;

          if (num >= simultaneousUploads) {
            should = false;
            return false;
          }
        }
      });
    }); // if should is true then return uploading chunks's length

    return should && num;
  },

  /**
   * Start or resume uploading.
   * @function
   */
  upload: function () {
    // Make sure we don't start too many uploads at once
    var ret = this._shouldUploadNext();

    if (ret === false) {
      return;
    } // Kick off the queue


    this.fire('uploadStart');
    var started = false;

    for (var num = 1; num <= this.opts.simultaneousUploads - ret; num++) {
      started = this.uploadNextChunk(true) || started;
    }

    if (!started) {
      async(function () {
        this.fire('complete');
      }, this);
    }
  },

  /**
   * Resume uploading.
   * @function
   */
  resume: function () {
    each(this.files, function (file) {
      if (!file.isComplete()) {
        file.resume();
      }
    });
  },

  /**
   * Pause uploading.
   * @function
   */
  pause: function () {
    each(this.files, function (file) {
      file.pause();
    });
  },

  /**
   * Cancel upload of all FlowFile objects and remove them from the list.
   * @function
   */
  cancel: function () {
    for (var i = this.files.length - 1; i >= 0; i--) {
      this.files[i].cancel();
    }
  },

  /**
   * Returns a number between 0 and 1 indicating the current upload progress
   * of all files.
   * @function
   * @returns {number}
   */
  progress: function () {
    var totalDone = 0;
    var totalSize = 0; // Resume all chunks currently being uploaded

    each(this.files, function (file) {
      totalDone += file.progress() * file.size;
      totalSize += file.size;
    });
    return totalSize > 0 ? totalDone / totalSize : 0;
  },

  /**
   * Add a HTML5 File object to the list of files.
   * @function
   * @param {File} file
   * @param {Event} [event] event is optional
   */
  addFile: function (file, event) {
    this.addFiles([file], event);
  },

  /**
   * Add a HTML5 File object to the list of files.
   * @function
   * @param {FileList|Array} fileList
   * @param {Event} [event] event is optional
   */
  addFiles: function (fileList, event) {
    var files = [];

    if (this.fire('filesAdding', fileList, event) == false) {
      return;
    }

    each(fileList, function (file) {
      // https://github.com/flowjs/flow.js/issues/55
      if ((!ie10plus || ie10plus && file.size > 0) && !(file.size % 4096 === 0 && (file.name === '.' || file.fileName === '.'))) {
        var uniqueIdentifier = this.generateUniqueIdentifier(file);

        if (this.opts.allowDuplicateUploads || !this.getFromUniqueIdentifier(uniqueIdentifier)) {
          var f = new FlowFile(this, file, uniqueIdentifier);

          if (this.fire('fileAdded', f, event)) {
            files.push(f);
          }
        }
      }
    }, this);

    if (this.fire('filesAdded', files, event)) {
      each(files, function (file) {
        if (this.opts.singleFile && this.files.length > 0) {
          this.removeFile(this.files[0]);
        }

        this.files.push(file);
      }, this);
      this.fire('filesSubmitted', files, event);
    }
  },

  /**
   * Cancel upload of a specific FlowFile object from the list.
   * @function
   * @param {FlowFile} file
   */
  removeFile: function (file) {
    for (var i = this.files.length - 1; i >= 0; i--) {
      if (this.files[i] === file) {
        this.files.splice(i, 1);
        file.abort();
        this.fire('fileRemoved', file);
      }
    }
  },

  /**
   * Look up a FlowFile object by its unique identifier.
   * @function
   * @param {string} uniqueIdentifier
   * @returns {boolean|FlowFile} false if file was not found
   */
  getFromUniqueIdentifier: function (uniqueIdentifier) {
    var ret = false;
    each(this.files, function (file) {
      if (file.uniqueIdentifier === uniqueIdentifier) {
        ret = file;
      }
    });
    return ret;
  },

  /**
   * Returns the total size of all files in bytes.
   * @function
   * @returns {number}
   */
  getSize: function () {
    var totalSize = 0;
    each(this.files, function (file) {
      totalSize += file.size;
    });
    return totalSize;
  },

  /**
   * Returns the total size uploaded of all files in bytes.
   * @function
   * @returns {number}
   */
  sizeUploaded: function () {
    var size = 0;
    each(this.files, function (file) {
      size += file.sizeUploaded();
    });
    return size;
  },

  /**
   * Returns remaining time to upload all files in seconds. Accuracy is based on average speed.
   * If speed is zero, time remaining will be equal to positive infinity `Number.POSITIVE_INFINITY`
   * @function
   * @returns {number}
   */
  timeRemaining: function () {
    var sizeDelta = 0;
    var averageSpeed = 0;
    each(this.files, function (file) {
      if (!file.paused && !file.error) {
        sizeDelta += file.size - file.sizeUploaded();
        averageSpeed += file.averageSpeed;
      }
    });

    if (sizeDelta && !averageSpeed) {
      return Number.POSITIVE_INFINITY;
    }

    if (!sizeDelta && !averageSpeed) {
      return 0;
    }

    return Math.floor(sizeDelta / averageSpeed);
  }
};
/**
 * FlowFile class
 * @name FlowFile
 * @param {Flow} flowObj
 * @param {File} file
 * @param {string} uniqueIdentifier
 * @constructor
 */

function FlowFile(flowObj, file, uniqueIdentifier) {
  /**
   * Reference to parent Flow instance
   * @type {Flow}
   */
  this.flowObj = flowObj;
  /**
   * Used to store the bytes read
   * @type {Blob|string}
   */

  this.bytes = null;
  /**
   * Reference to file
   * @type {File}
   */

  this.file = file;
  /**
   * File name. Some confusion in different versions of Firefox
   * @type {string}
   */

  this.name = file.fileName || file.name;
  /**
   * File size
   * @type {number}
   */

  this.size = file.size;
  /**
   * Relative file path
   * @type {string}
   */

  this.relativePath = file.relativePath || file.webkitRelativePath || this.name;
  /**
   * File unique identifier
   * @type {string}
   */

  this.uniqueIdentifier = uniqueIdentifier === undefined ? flowObj.generateUniqueIdentifier(file) : uniqueIdentifier;
  /**
   * Size of Each Chunk
   * @type {number}
   */

  this.chunkSize = 0;
  /**
   * List of chunks
   * @type {Array.<FlowChunk>}
   */

  this.chunks = [];
  /**
   * Indicated if file is paused
   * @type {boolean}
   */

  this.paused = false;
  /**
   * Indicated if file has encountered an error
   * @type {boolean}
   */

  this.error = false;
  /**
   * Average upload speed
   * @type {number}
   */

  this.averageSpeed = 0;
  /**
   * Current upload speed
   * @type {number}
   */

  this.currentSpeed = 0;
  /**
   * Date then progress was called last time
   * @type {number}
   * @private
   */

  this._lastProgressCallback = Date.now();
  /**
   * Previously uploaded file size
   * @type {number}
   * @private
   */

  this._prevUploadedSize = 0;
  /**
   * Holds previous progress
   * @type {number}
   * @private
   */

  this._prevProgress = 0;
  this.bootstrap();
}

FlowFile.prototype = {
  /**
   * Update speed parameters
   * @link http://stackoverflow.com/questions/2779600/how-to-estimate-download-time-remaining-accurately
   * @function
   */
  measureSpeed: function () {
    var timeSpan = Date.now() - this._lastProgressCallback;

    if (!timeSpan) {
      return;
    }

    var smoothingFactor = this.flowObj.opts.speedSmoothingFactor;
    var uploaded = this.sizeUploaded(); // Prevent negative upload speed after file upload resume

    this.currentSpeed = Math.max((uploaded - this._prevUploadedSize) / timeSpan * 1000, 0);
    this.averageSpeed = smoothingFactor * this.currentSpeed + (1 - smoothingFactor) * this.averageSpeed;
    this._prevUploadedSize = uploaded;
  },

  /**
   * For internal usage only.
   * Callback when something happens within the chunk.
   * @function
   * @param {FlowChunk} chunk
   * @param {string} event can be 'progress', 'success', 'error' or 'retry'
   * @param {string} [message]
   */
  chunkEvent: function (chunk, event, message) {
    switch (event) {
      case 'progress':
        if (Date.now() - this._lastProgressCallback < this.flowObj.opts.progressCallbacksInterval) {
          break;
        }

        this.measureSpeed();
        this.flowObj.fire('fileProgress', this, chunk);
        this.flowObj.fire('progress');
        this._lastProgressCallback = Date.now();
        break;

      case 'error':
        this.error = true;
        this.abort(true);
        this.flowObj.fire('fileError', this, message, chunk);
        this.flowObj.fire('error', message, this, chunk);
        break;

      case 'success':
        if (this.error) {
          return;
        }

        this.measureSpeed();
        this.flowObj.fire('fileProgress', this, chunk);
        this.flowObj.fire('progress');
        this._lastProgressCallback = Date.now();

        if (this.isComplete()) {
          this.currentSpeed = 0;
          this.averageSpeed = 0;
          this.flowObj.fire('fileSuccess', this, message, chunk);
        }

        break;

      case 'retry':
        this.flowObj.fire('fileRetry', this, chunk);
        break;
    }
  },

  /**
   * Pause file upload
   * @function
   */
  pause: function () {
    this.paused = true;
    this.abort();
  },

  /**
   * Resume file upload
   * @function
   */
  resume: function () {
    this.paused = false;
    this.flowObj.upload();
  },

  /**
   * Abort current upload
   * @function
   */
  abort: function (reset) {
    this.currentSpeed = 0;
    this.averageSpeed = 0;
    var chunks = this.chunks;

    if (reset) {
      this.chunks = [];
    }

    each(chunks, function (c) {
      if (c.status() === 'uploading') {
        c.abort();
        this.flowObj.uploadNextChunk();
      }
    }, this);
  },

  /**
   * Cancel current upload and remove from a list
   * @function
   */
  cancel: function () {
    this.flowObj.removeFile(this);
  },

  /**
   * Retry aborted file upload
   * @function
   */
  retry: function () {
    this.bootstrap();
    this.flowObj.upload();
  },

  /**
   * Clear current chunks and slice file again
   * @function
   */
  bootstrap: function () {
    if (typeof this.flowObj.opts.initFileFn === 'function') {
      this.flowObj.opts.initFileFn(this);
    }

    this.abort(true);
    this.error = false; // Rebuild stack of chunks from file

    this._prevProgress = 0;
    var round = this.flowObj.opts.forceChunkSize ? Math.ceil : Math.floor;
    this.chunkSize = evalOpts(this.flowObj.opts.chunkSize, this);
    var chunks = Math.max(round(this.size / this.chunkSize), 1);

    for (var offset = 0; offset < chunks; offset++) {
      this.chunks.push(new FlowChunk(this.flowObj, this, offset));
    }
  },

  /**
   * Get current upload progress status
   * @function
   * @returns {number} from 0 to 1
   */
  progress: function () {
    if (this.error) {
      return 1;
    }

    if (this.chunks.length === 1) {
      this._prevProgress = Math.max(this._prevProgress, this.chunks[0].progress());
      return this._prevProgress;
    } // Sum up progress across everything


    var bytesLoaded = 0;
    each(this.chunks, function (c) {
      // get chunk progress relative to entire file
      bytesLoaded += c.progress() * (c.endByte - c.startByte);
    });
    var percent = bytesLoaded / this.size; // We don't want to lose percentages when an upload is paused

    this._prevProgress = Math.max(this._prevProgress, percent > 0.9999 ? 1 : percent);
    return this._prevProgress;
  },

  /**
   * Indicates if file is being uploaded at the moment
   * @function
   * @returns {boolean}
   */
  isUploading: function () {
    var uploading = false;
    each(this.chunks, function (chunk) {
      if (chunk.status() === 'uploading') {
        uploading = true;
        return false;
      }
    });
    return uploading;
  },

  /**
   * Indicates if file is has finished uploading and received a response
   * @function
   * @returns {boolean}
   */
  isComplete: function () {
    var outstanding = false;
    each(this.chunks, function (chunk) {
      var status = chunk.status();

      if (status === 'pending' || status === 'uploading' || status === 'reading' || chunk.preprocessState === 1 || chunk.readState === 1) {
        outstanding = true;
        return false;
      }
    });
    return !outstanding;
  },

  /**
   * Count total size uploaded
   * @function
   * @returns {number}
   */
  sizeUploaded: function () {
    var size = 0;
    each(this.chunks, function (chunk) {
      size += chunk.sizeUploaded();
    });
    return size;
  },

  /**
   * Returns remaining time to finish upload file in seconds. Accuracy is based on average speed.
   * If speed is zero, time remaining will be equal to positive infinity `Number.POSITIVE_INFINITY`
   * @function
   * @returns {number}
   */
  timeRemaining: function () {
    if (this.paused || this.error) {
      return 0;
    }

    var delta = this.size - this.sizeUploaded();

    if (delta && !this.averageSpeed) {
      return Number.POSITIVE_INFINITY;
    }

    if (!delta && !this.averageSpeed) {
      return 0;
    }

    return Math.floor(delta / this.averageSpeed);
  },

  /**
   * Get file type
   * @function
   * @returns {string}
   */
  getType: function () {
    return this.file.type && this.file.type.split('/')[1];
  },

  /**
   * Get file extension
   * @function
   * @returns {string}
   */
  getExtension: function () {
    return this.name.substr((~-this.name.lastIndexOf('.') >>> 0) + 2).toLowerCase();
  }
};
/**
 * Default read function using the webAPI
 *
 * @function webAPIFileRead(fileObj, startByte, endByte, fileType, chunk)
 *
 */

function webAPIFileRead(fileObj, startByte, endByte, fileType, chunk) {
  var function_name = 'slice';
  if (fileObj.file.slice) function_name = 'slice';else if (fileObj.file.mozSlice) function_name = 'mozSlice';else if (fileObj.file.webkitSlice) function_name = 'webkitSlice';
  chunk.readFinished(fileObj.file[function_name](startByte, endByte, fileType));
}
/**
 * Class for storing a single chunk
 * @name FlowChunk
 * @param {Flow} flowObj
 * @param {FlowFile} fileObj
 * @param {number} offset
 * @constructor
 */


function FlowChunk(flowObj, fileObj, offset) {
  /**
   * Reference to parent flow object
   * @type {Flow}
   */
  this.flowObj = flowObj;
  /**
   * Reference to parent FlowFile object
   * @type {FlowFile}
   */

  this.fileObj = fileObj;
  /**
   * File offset
   * @type {number}
   */

  this.offset = offset;
  /**
   * Indicates if chunk existence was checked on the server
   * @type {boolean}
   */

  this.tested = false;
  /**
   * Number of retries performed
   * @type {number}
   */

  this.retries = 0;
  /**
   * Pending retry
   * @type {boolean}
   */

  this.pendingRetry = false;
  /**
   * Preprocess state
   * @type {number} 0 = unprocessed, 1 = processing, 2 = finished
   */

  this.preprocessState = 0;
  /**
   * Read state
   * @type {number} 0 = not read, 1 = reading, 2 = finished
   */

  this.readState = 0;
  /**
   * Bytes transferred from total request size
   * @type {number}
   */

  this.loaded = 0;
  /**
   * Total request size
   * @type {number}
   */

  this.total = 0;
  /**
   * Size of a chunk
   * @type {number}
   */

  this.chunkSize = this.fileObj.chunkSize;
  /**
   * Chunk start byte in a file
   * @type {number}
   */

  this.startByte = this.offset * this.chunkSize;
  /**
   * A specific filename for this chunk which otherwise default to the main name
   * @type {string}
   */

  this.filename = null;
  /**
   * Compute the endbyte in a file
   *
   */

  this.computeEndByte = function () {
    var endByte = Math.min(this.fileObj.size, (this.offset + 1) * this.chunkSize);

    if (this.fileObj.size - endByte < this.chunkSize && !this.flowObj.opts.forceChunkSize) {
      // The last chunk will be bigger than the chunk size,
      // but less than 2 * this.chunkSize
      endByte = this.fileObj.size;
    }

    return endByte;
  };
  /**
   * Chunk end byte in a file
   * @type {number}
   */


  this.endByte = this.computeEndByte();
  /**
   * XMLHttpRequest
   * @type {XMLHttpRequest}
   */

  this.xhr = null;
  var $ = this;
  /**
   * Send chunk event
   * @param event
   * @param {...} args arguments of a callback
   */

  this.event = function (event, args) {
    args = Array.prototype.slice.call(arguments);
    args.unshift($);
    $.fileObj.chunkEvent.apply($.fileObj, args);
  };
  /**
   * Catch progress event
   * @param {ProgressEvent} event
   */


  this.progressHandler = function (event) {
    if (event.lengthComputable) {
      $.loaded = event.loaded;
      $.total = event.total;
    }

    $.event('progress', event);
  };
  /**
   * Catch test event
   * @param {Event} event
   */


  this.testHandler = function (event) {
    var status = $.status(true);

    if (status === 'error') {
      $.event(status, $.message());
      $.flowObj.uploadNextChunk();
    } else if (status === 'success') {
      $.tested = true;
      $.event(status, $.message());
      $.flowObj.uploadNextChunk();
    } else if (!$.fileObj.paused) {
      // Error might be caused by file pause method
      // Chunks does not exist on the server side
      $.tested = true;
      $.send();
    }
  };
  /**
   * Upload has stopped
   * @param {Event} event
   */


  this.doneHandler = function (event) {
    var status = $.status();

    if (status === 'success' || status === 'error') {
      delete this.data;
      $.event(status, $.message());
      $.flowObj.uploadNextChunk();
    } else if (!$.fileObj.paused) {
      $.event('retry', $.message());
      $.pendingRetry = true;
      $.abort();
      $.retries++;
      var retryInterval = $.flowObj.opts.chunkRetryInterval;

      if (retryInterval !== null) {
        setTimeout(function () {
          $.send();
        }, retryInterval);
      } else {
        $.send();
      }
    }
  };
}

FlowChunk.prototype = {
  /**
   * Get params for a request
   * @function
   */
  getParams: function () {
    return {
      flowChunkNumber: this.offset + 1,
      flowChunkSize: this.chunkSize,
      flowCurrentChunkSize: this.endByte - this.startByte,
      flowTotalSize: this.fileObj.size,
      flowIdentifier: this.fileObj.uniqueIdentifier,
      flowFilename: this.fileObj.name,
      flowRelativePath: this.fileObj.relativePath,
      flowTotalChunks: this.fileObj.chunks.length
    };
  },

  /**
   * Get target option with query params
   * @function
   * @param params
   * @returns {string}
   */
  getTarget: function (target, params) {
    if (params.length == 0) {
      return target;
    }

    if (target.indexOf('?') < 0) {
      target += '?';
    } else {
      target += '&';
    }

    return target + params.join('&');
  },

  /**
   * Makes a GET request without any data to see if the chunk has already
   * been uploaded in a previous session
   * @function
   */
  test: function () {
    // Set up request and listen for event
    this.xhr = new XMLHttpRequest();
    this.xhr.addEventListener('load', this.testHandler, false);
    this.xhr.addEventListener('error', this.testHandler, false);
    var testMethod = evalOpts(this.flowObj.opts.testMethod, this.fileObj, this);
    var data = this.prepareXhrRequest(testMethod, true);
    this.xhr.send(data);
  },

  /**
   * Finish preprocess state
   * @function
   */
  preprocessFinished: function () {
    // Re-compute the endByte after the preprocess function to allow an
    // implementer of preprocess to set the fileObj size
    this.endByte = this.computeEndByte();
    this.preprocessState = 2;
    this.send();
  },

  /**
   * Finish read state
   * @function
   */
  readFinished: function (bytes) {
    this.readState = 2;
    this.bytes = bytes;
    this.send();
  },

  /**
   * Uploads the actual data in a POST call
   * @function
   */
  send: function () {
    var preprocess = this.flowObj.opts.preprocess;
    var read = this.flowObj.opts.readFileFn;

    if (typeof preprocess === 'function') {
      switch (this.preprocessState) {
        case 0:
          this.preprocessState = 1;
          preprocess(this);
          return;

        case 1:
          return;
      }
    }

    switch (this.readState) {
      case 0:
        this.readState = 1;
        read(this.fileObj, this.startByte, this.endByte, this.fileObj.file.type, this);
        return;

      case 1:
        return;
    }

    if (this.flowObj.opts.testChunks && !this.tested) {
      this.test();
      return;
    }

    this.loaded = 0;
    this.total = 0;
    this.pendingRetry = false; // Set up request and listen for event

    this.xhr = new XMLHttpRequest();
    this.xhr.upload.addEventListener('progress', this.progressHandler, false);
    this.xhr.addEventListener('load', this.doneHandler, false);
    this.xhr.addEventListener('error', this.doneHandler, false);
    var uploadMethod = evalOpts(this.flowObj.opts.uploadMethod, this.fileObj, this);
    var data = this.prepareXhrRequest(uploadMethod, false, this.flowObj.opts.method, this.bytes);
    var changeRawDataBeforeSend = this.flowObj.opts.changeRawDataBeforeSend;

    if (typeof changeRawDataBeforeSend === 'function') {
      data = changeRawDataBeforeSend(this, data);
    }

    this.xhr.send(data);
  },

  /**
   * Abort current xhr request
   * @function
   */
  abort: function () {
    // Abort and reset
    var xhr = this.xhr;
    this.xhr = null;

    if (xhr) {
      xhr.abort();
    }
  },

  /**
   * Retrieve current chunk upload status
   * @function
   * @returns {string} 'pending', 'uploading', 'success', 'error'
   */
  status: function (isTest) {
    if (this.readState === 1) {
      return 'reading';
    } else if (this.pendingRetry || this.preprocessState === 1) {
      // if pending retry then that's effectively the same as actively uploading,
      // there might just be a slight delay before the retry starts
      return 'uploading';
    } else if (!this.xhr) {
      return 'pending';
    } else if (this.xhr.readyState < 4) {
      // Status is really 'OPENED', 'HEADERS_RECEIVED'
      // or 'LOADING' - meaning that stuff is happening
      return 'uploading';
    } else {
      if (this.flowObj.opts.successStatuses.indexOf(this.xhr.status) > -1) {
        // HTTP 200, perfect
        // HTTP 202 Accepted - The request has been accepted for processing, but the processing has not been completed.
        return 'success';
      } else if (this.flowObj.opts.permanentErrors.indexOf(this.xhr.status) > -1 || !isTest && this.retries >= this.flowObj.opts.maxChunkRetries) {
        // HTTP 413/415/500/501, permanent error
        return 'error';
      } else {
        // this should never happen, but we'll reset and queue a retry
        // a likely case for this would be 503 service unavailable
        this.abort();
        return 'pending';
      }
    }
  },

  /**
   * Get response from xhr request
   * @function
   * @returns {String}
   */
  message: function () {
    return this.xhr ? this.xhr.responseText : '';
  },

  /**
   * Get upload progress
   * @function
   * @returns {number}
   */
  progress: function () {
    if (this.pendingRetry) {
      return 0;
    }

    var s = this.status();

    if (s === 'success' || s === 'error') {
      return 1;
    } else if (s === 'pending') {
      return 0;
    } else {
      return this.total > 0 ? this.loaded / this.total : 0;
    }
  },

  /**
   * Count total size uploaded
   * @function
   * @returns {number}
   */
  sizeUploaded: function () {
    var size = this.endByte - this.startByte; // can't return only chunk.loaded value, because it is bigger than chunk size

    if (this.status() !== 'success') {
      size = this.progress() * size;
    }

    return size;
  },

  /**
   * Prepare Xhr request. Set query, headers and data
   * @param {string} method GET or POST
   * @param {bool} isTest is this a test request
   * @param {string} [paramsMethod] octet or form
   * @param {Blob} [blob] to send
   * @returns {FormData|Blob|Null} data to send
   */
  prepareXhrRequest: function (method, isTest, paramsMethod, blob) {
    // Add data from the query options
    var query = evalOpts(this.flowObj.opts.query, this.fileObj, this, isTest);
    query = extend(query || {}, this.getParams());
    var target = evalOpts(this.flowObj.opts.target, this.fileObj, this, isTest);
    var data = null;

    if (method === 'GET' || paramsMethod === 'octet') {
      // Add data from the query options
      var params = [];
      each(query, function (v, k) {
        params.push([encodeURIComponent(k), encodeURIComponent(v)].join('='));
      });
      target = this.getTarget(target, params);
      data = blob || null;
    } else {
      // Add data from the query options
      data = new FormData();
      each(query, function (v, k) {
        data.append(k, v);
      });

      if (typeof blob !== 'undefined') {
        data.append(this.flowObj.opts.fileParameterName, blob, this.filename || this.fileObj.file.name);
      }
    }

    this.xhr.open(method, target, true);
    this.xhr.withCredentials = this.flowObj.opts.withCredentials; // Add data from header options

    each(evalOpts(this.flowObj.opts.headers, this.fileObj, this, isTest), function (v, k) {
      this.xhr.setRequestHeader(k, v);
    }, this);
    return data;
  }
};
/**
 * Remove value from array
 * @param array
 * @param value
 */

function arrayRemove(array, value) {
  var index = array.indexOf(value);

  if (index > -1) {
    array.splice(index, 1);
  }
}
/**
 * If option is a function, evaluate it with given params
 * @param {*} data
 * @param {...} args arguments of a callback
 * @returns {*}
 */


function evalOpts(data, args) {
  if (typeof data === 'function') {
    // `arguments` is an object, not array, in FF, so:
    args = Array.prototype.slice.call(arguments);
    data = data.apply(null, args.slice(1));
  }

  return data;
}

Flow.evalOpts = evalOpts;
/**
 * Execute function asynchronously
 * @param fn
 * @param context
 */

function async(fn, context) {
  setTimeout(fn.bind(context), 0);
}
/**
 * Extends the destination object `dst` by copying all of the properties from
 * the `src` object(s) to `dst`. You can specify multiple `src` objects.
 * @function
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */


function extend(dst, src) {
  each(arguments, function (obj) {
    if (obj !== dst) {
      each(obj, function (value, key) {
        dst[key] = value;
      });
    }
  });
  return dst;
}

Flow.extend = extend;
/**
 * Iterate each element of an object
 * @function
 * @param {Array|Object} obj object or an array to iterate
 * @param {Function} callback first argument is a value and second is a key.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 */

function each(obj, callback, context) {
  if (!obj) {
    return;
  }

  var key; // Is Array?
  // Array.isArray won't work, not only arrays can be iterated by index https://github.com/flowjs/ng-flow/issues/236#

  if (typeof obj.length !== 'undefined') {
    for (key = 0; key < obj.length; key++) {
      if (callback.call(context, obj[key], key) === false) {
        return;
      }
    }
  } else {
    for (key in obj) {
      if (obj.hasOwnProperty(key) && callback.call(context, obj[key], key) === false) {
        return;
      }
    }
  }
}

Flow.each = each;
/**
 * FlowFile constructor
 * @type {FlowFile}
 */

Flow.FlowFile = FlowFile;
/**
 * FlowFile constructor
 * @type {FlowChunk}
 */

Flow.FlowChunk = FlowChunk;
/**
 * Library version
 * @type {string}
 */

Flow.version = '<%= version %>';
var flow = Flow;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm._m(0);
};

var __vue_staticRenderFns__ = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('table', {
    staticClass: "flow-list"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": ""
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "250px"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "100px"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("Progress")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]);
}];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAAGklEQVQYV2Pwarf5D8NAwADCyGIMowqIUwAAnJO2ldo7HlkAAAAASUVORK5CYII=";

var pause = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$4
});

var img$5 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAARUlEQVQYlWPward5AMQODLgAUPI/FC8AYgF8CkD4AxAH4FMAwweAWAGfAphpDfgUgPAEXAouALEBLkcW4HLkBlzexBtQAGO/YbROsq3TAAAAAElFTkSuQmCC";

var resume = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$5
});

var img$6 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sEDw4oLHzVH5kAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAWklEQVQY042QUQrAMAhDozfrX8/UffdM3Vd3tOxnLWFzYEAQH6gJSGKORpKIajGboxGPSu0G0XUem7lCBdqX2s1IfoBqLfK/s++ZIymPfgrNRI9HBtPxIBv4Da5baG9ObScpAAAAAElFTkSuQmCC";

var cancel = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': img$6
});

var require$$0$1 = getCjsExportFromNamespace(pause);

var require$$1$1 = getCjsExportFromNamespace(resume);

var require$$2$1 = getCjsExportFromNamespace(cancel);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  props: {
    file: Object
  },

  data() {
    return {
      icons: {
        resume: null,
        cancel: null,
        pause: null
      },
      images: ({} = {
        doc: ['docx', 'docm', 'doc', 'dotx', 'dotm', 'dot', 'rtf'],
        excel: ['xlsx', 'xlsm', 'xlsb', 'xls', 'csv', 'xltx'],
        ppt: ['pptx', 'pptm', 'ppt', 'potx', 'potm', 'pot', 'ppsx', 'ppsm', 'pps'],
        img: ['png', 'jpg', 'jpeg', 'gif'],
        pdf: ['pdf'],
        txt: ['txt', 'log', 'xml'],
        zip: ['zip', '7z', 'gz']
      })
    };
  },

  created() {
    this.icons.pause = require$$0$1;
    this.icons.resume = require$$1$1;
    this.icons.cancel = require$$2$1;
  },

  methods: {
    getExtensions(filename) {
      return filename.split('.').pop();
    },

    imageUrl(file) {
      const ext = this.getExtensions(file.name);
      var aa = 'default';

      if (ext) {
        var key = Object.keys(this.images).find(key => {
          var supports = this.images[key];
          return supports.includes(ext === null || ext === void 0 ? void 0 : ext.toLowerCase());
        });

        if (key) {
          aa = key;
        }
      }

      return `/cm/gres/v1/img/type_${aa}.png`;
    },

    getSize(size) {
      return readablizeBytes(size);
    },

    downlaod() {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(this.file.blob, this.file.name);
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(this.file.blob);
        link.download = `${this.file.name}`;
        link.click();
      }
    },

    readablizeBytes(bytes) {
      var s = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
      var e = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + s[e];
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "con-left"
  }, [_c('div', {
    staticClass: "image attach-file"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl(_vm.file)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "con-right"
  }, [_c('h6', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.file.name))]), _vm._v(" "), _c('p', {
    staticClass: "file-size"
  }, [_vm._v(" " + _vm._s(_vm.readablizeBytes(_vm.file.size)))])]), _vm._v(" "), _c('div', {
    staticClass: "con-right m-l-l"
  }, [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.$emit('delete', _vm.file);
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])])]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
var script$2 = {
  components: {
    FileListHeader: __vue_component__,
    FileListItem: __vue_component__$1
  },
  props: {
    files: Array
  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "read-file-wrap"
  }, _vm._l(_vm.files, function (file, index) {
    return _c("file-list-item", {
      key: index,
      tag: "div",
      staticClass: "file-item",
      class: 'flow-file-' + file.uniqueIdentifier,
      attrs: {
        "file": file
      },
      on: {
        "delete": function (file) {
          return _vm.$emit('delete', file);
        },
        "resume": function (file) {
          return _vm.$emit('resume', file);
        }
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = "data-v-38e252f4";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var script$3 = {
  components: {
    FileList: __vue_component__$2
  },
  directives: {
    flow: {
      inserted: function (el, binding, vnode) {
        console.log('inserted');
        const flowDrop = '#flowDrop'; // const flowBrowseImage = '';

        const {
          flow,
          browseButton,
          browseFolderButton
        } = vnode.context;

        const query = query => window.document.body.querySelector(query);

        if (flow) {
          {
            let found = query(flowDrop);

            if (found) {
              flow.assignDrop(found);
            }
          }

          if (browseButton) {
            let found = query(browseButton);

            if (found) {
              flow.assignBrowse(found);
            }
          }

          if (browseFolderButton) {
            let found = query(browseFolderButton);

            if (found) {
              flow.assignBrowse(found, true);
            }
          } // if (flowBrowseImage) {
          //     var found = query(flowBrowseImage);
          //     flow.assignBrowse(found, false, false, {
          //         accept: 'image/*',
          //     });
          // }

        } else {
          throw new Error('The flow object has not been initialized.');
        }
      }
    }
  },
  props: {
    uploadUrl: String,
    deleteUrl: String,
    deleteMethod: String,
    code: String,
    codeValues: Array,
    chunkSize: Number,
    simultaneousUploads: Number,
    value: Array,
    browseButton: String,
    browseFolderButton: String,
    customDelete: Function,
    // (files: any[]) => Promise<boolean>

    /**
     * 전체 파일 크기 제한.
     */
    totalSizeLimit: Number,
    totalSizeLimitExcessMessage: String,
    emptyFileDenialMessage: String,

    /**
     * 업로드 제한 파일 확장자
     */
    bannedExtentions: Array,
    //[".",]
    bannedExtentionMessage: String
  },
  watch: {
    browseButton(value) {
      console.log('eum-file-upload', 'browseButton', this.flow, value);

      if (this.flow && value) {
        this.flow.assignBrowse(value);
      }
    },

    browseFolderButton(value) {
      if (this.flow && value) {
        this.flow.assignBrowse(value, true);
      }
    },

    code(value) {
      if (this.flow) {
        this.flow.setQuery({ ...this.flow.getQuery(),
          code: value
        });
      }
    },

    codeValues(value) {
      if (this.flow) {
        this.flow.setQuery({ ...this.flow.getQuery(),
          codeValues: value
        });
      }
    }

  },
  computed: {
    files: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      }

    }
  },

  data() {
    return {
      flow: null,
      isNotSupported: false,
      dragin: false
    };
  },

  methods: {
    upload() {
      this.flow.upload();
    },

    resume() {
      this.flow.resume();
    },

    pause() {
      this.flow.pause();
      this.$emit('stateChanged', 'paused');
    },

    cancel() {
      this.flow.cancel();
      this.$emit('stateChanged', 'canceled');
      this.deleteAllFiles();
    },

    selected(file) {
      file.selected = true;
      this.$emit('selectionChanged', this.files.filter(f => f.selected));
    },

    deleteSelectedFiles() {
      const files = this.files.filter(f => f.selected);

      if (files.length == 0) {
        return alert('삭제하려는 파일을 선택하세요.');
      }

      this.deleteFiles(files);
    },

    deleteAllFiles() {
      this.deleteFiles(this.files);
    },

    pauseFile(file) {
      const {
        id
      } = file; // Find a FlowFile object.

      console.log('flow.files', this.flow.files);
      var found = this.flow.files.find(f => id === f.uniqueIdentifier);
      console.log('pauseFile', file, found);

      if (found) {
        if (!found.paused) {
          found.pause();
        }
      }
    },

    resumeFile(file) {
      const {
        id
      } = file; // Find a FlowFile object.

      console.log('flow.files', this.flow.files);
      var found = this.flow.files.find(f => id === f.uniqueIdentifier);
      console.log('resumeFile', file, found);

      if (found) {
        if (found.paused) {
          console.log('resume');
          found.resume();
        } else {
          console.log('retry');
          found.retry();
        }
      }
    },

    deleteFiles(files
    /*: File[]*/
    ) {
      console.log('eum-file-upload', 'deleteFiles', files);
      const flow = this.flow;

      const processResult = origins => {
        for (let idx in origins) {
          const file = origins[idx];
          var flowFile = flow.files.filter(uf => file.id === uf.uniqueIdentifier)[0];

          if (flowFile) {
            // Remove files from flow queue.
            flow.removeFile(flowFile);
          } else {
            this.fileRemoved(file);
          }
        }
      };

      const customs = files.filter(file => file.custom === true);

      if (customs && customs.length > 0) {
        this.customDelete(customs).then(succeed => {
          if (succeed) {
            processResult(customs);
          }
        });
      }

      const origins = files; //.filter((file) => !file.custom);

      if (origins && origins.length > 0) {
        var data = {
          code: this.code,
          codeValues: this.codeValues,
          fileNames: origins.map(f => f.name)
        };
        return fetch(this.deleteUrl, {
          method: this.deleteMethod || 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json' // 'Content-Type': 'multipart/form-data'

          },
          body: JSON.stringify(data)
        }).then(() => {
          processResult(origins);
        });
      }
    },

    secondsToStr(temp) {
      function numberEnding(number) {
        return number > 1 ? 's' : '';
      }

      var years = Math.floor(temp / 31536000);

      if (years) {
        return years + ' year' + numberEnding(years);
      }

      var days = Math.floor((temp %= 31536000) / 86400);

      if (days) {
        return days + ' day' + numberEnding(days);
      }

      var hours = Math.floor((temp %= 86400) / 3600);

      if (hours) {
        return hours + ' hour' + numberEnding(hours);
      }

      var minutes = Math.floor((temp %= 3600) / 60);

      if (minutes) {
        return minutes + ' minute' + numberEnding(minutes);
      }

      var seconds = temp % 60;
      return seconds + ' second' + numberEnding(seconds);
    },

    readablizeBytes(bytes) {
      var s = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
      var e = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + s[e];
    },

    setFileState(id, state) {
      console.log('setFileState', id, state);
      var file = this.files.filter(f => f.id === id)[0];
      file.status = state;
    },

    filesAdding(files) {
      console.log('eum-file-upload', 'filesAdding', files);

      if ([...files].filter(f => f.size === 0).length > 0) {
        if (typeof this.emptyFileDenialMessage === 'string') {
          alert(this.emptyFileDenialMessage);
        }

        return false;
      }

      if (typeof this.totalSizeLimit === 'number') {
        if ([...this.files, ...files].map(f => f.size).reduce((a, b) => a + b, 0) > this.totalSizeLimit) {
          if (typeof this.totalSizeLimitExcessMessage === 'string') {
            alert(this.totalSizeLimitExcessMessage);
          }

          return false;
        }
      }

      if (this.bannedExtentions != undefined && this.bannedExtentions != null) {
        var filtered = [...files].filter(f => {
          var match = f.name.match(/[^.]+$/);
          var extension = match == null ? '' : match[0];
          if (this.bannedExtentions.indexOf(extension) >= 0) return true;else return false;
        });

        if (filtered.length > 0) {
          alert(this.bannedExtentionMessage);
          return false;
        }
      }
    },

    //#region [ Handle file upload events ]
    fileAdded(fileData) {
      this.$emit('change');
      console.log('fileAdded', fileData.file.type, fileData); // Create a blob field

      fileData.blob = '';
      let URL = window.URL || window.webkitURL;

      if (URL && URL.createObjectURL && fileData.file) {
        fileData.blob = URL.createObjectURL(fileData.file);
      } // Thumbnails


      fileData.thumb = '';
      const filetype = fileData.file.type || '';

      if (fileData.blob && filetype.substr(0, 6) === 'image/') {
        fileData.thumb = fileData.blob;
      } else {
        const icons = {
          'officedocument.presentationml.presentation': require$$0,
          'officedocument.spreadsheetml.sheet': require$$1,
          'officedocument.wordprocessingml.document': require$$2
        };
        const iconNames = Object.keys(icons).filter(key => filetype.includes(key));

        if (iconNames && iconNames.length > 0) {
          fileData.thumb = icons[iconNames[0]];
        } else {
          fileData.thumb = require$$3;
        }
      }

      this.files.push({
        id: fileData.uniqueIdentifier,
        uniqueIdentifier: fileData.uniqueIdentifier,
        name: fileData.name,
        size: fileData.size,
        percent: '',
        status: 'ready',
        time: '',
        selected: false,
        thumb: fileData.thumb,
        blob: fileData.file
      });
      this.$emit('itemsChanged', this.files);
    },

    fileRemoved(file) {
      this.$emit('change'); // Remove files from file list UI

      var results = this.files.filter(f => f.id === file.id);

      if (results.length > 0) {
        var index = this.files.indexOf(results[0]);
        this.files.splice(index, 1);
      }

      this.$emit('itemsChanged', this.files);
    },

    filesSubmitted(file) {
      this.flow.upload();
    },

    complete() {
      this.$emit('stateChanged', 'complete');
    },

    fileSuccess(file) {
      console.log('fileSuccess', file);
      const {
        uniqueIdentifier
      } = file;
      this.setFileState(uniqueIdentifier, 'succeed');
    },

    fileError(file) {
      console.log('fileError', file); // file.resume();

      this.fileProgress(file);
    },

    fileRetry(file, chunk) {},

    fileProgress(file) {
      const {
        uniqueIdentifier,
        error
      } = file;
      this.setFileState(uniqueIdentifier, error ? 'error' : 'uploading');
      const fileState = this.files.filter(f => f.id === uniqueIdentifier)[0];
      console.log('fileProgress', file, file.error, file.progress());
      const percent = file.error ? 0 : Math.floor(file.progress() * 100); // const percent = Math.floor(file.progress() * 100);

      console.log('fileProgress.percent', percent);
      const size = this.readablizeBytes(file.averageSpeed);
      const time = this.secondsToStr(file.timeRemaining());
      fileState.percent = percent;
      fileState.sizePerSeconds = size;
      fileState.time = time;
    },

    uploadStart(file) {
      this.$emit('stateChanged', 'uploading');
    },

    catchAll(file) {} //#endregion


  },

  created() {
    if (!this.flow) {
      const flow$1 = this.flow = new flow({
        target: this.uploadUrl,
        singleFile: false,
        simultaneousUploads: this.simultaneousUploads,
        chunkSize: this.chunkSize,
        testChunks: false,
        chunkRetryInterval: 10,
        query: {
          code: this.code,
          codeValues: this.codeValues
        }
      });
      console.log('file-upload', 'initFlow', 'begin', flow$1);

      if (!flow$1.support) {
        this.isNotSupported = true;
      }

      const events = {
        fileAdded: this.fileAdded,
        filesAdding: this.filesAdding,
        fileRemoved: this.fileRemoved,
        filesSubmitted: this.filesSubmitted,
        complete: this.complete,
        fileSuccess: this.fileSuccess,
        fileError: this.fileError,
        fileProgress: this.fileProgress,
        uploadStart: this.uploadStart,
        catchAll: this.catchAll,
        fileRetry: this.fileRetry
      };
      Object.keys(events).forEach(name => flow$1.on(name, events[name]));
      this.$emit('stateChanged', 'ready');
    }
  }

};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {}, [_vm.code && _vm.codeValues && _vm.codeValues.length > 0 ? _c('div', {
    directives: [{
      name: "flow",
      rawName: "v-flow"
    }],
    ref: "flowDrop",
    class: {
      'file-dragover': _vm.dragin
    },
    attrs: {
      "id": "flowDrop"
    },
    on: {
      "dragenter": function ($event) {
        _vm.dragin = true;
      },
      "dragend": function ($event) {
        _vm.dragin = false;
      },
      "dragleave": function ($event) {
        _vm.dragin = false;
      },
      "drop": function ($event) {
        _vm.dragin = false;
      }
    }
  }, [_vm.files && _vm.files.length > 0 ? _c('FileList', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "files": _vm.files
    },
    on: {
      "pause": function (file) {
        return _vm.pauseFile(file);
      },
      "delete": function (file) {
        return _vm.deleteFiles([file]);
      },
      "resume": function (file) {
        return _vm.resumeFile(file);
      }
    }
  }) : _vm._e()], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

// Import vue component

const install = function installEumFileUpload(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('EumFileUpload', __vue_component__$3);
}; // Create module definition for Vue.use()


const plugin = {
  install
}; // To auto-install when vue is found
// eslint-disable-next-line no-redeclare

/* global window, global */

let GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
} // Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()


__vue_component__$3.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__$3;
